import React, { useEffect, useState } from "react";
import Pagination from 'antd/lib/pagination';
import message from 'antd/lib/message';
import Select from 'antd/lib/select';
import Popconfirm from 'antd/lib/popconfirm';
import Button from 'antd/lib/button';
import { Alert } from "antd";
import { SendOutlined } from '@ant-design/icons';
import { PlusCircleTwoTone } from '@ant-design/icons';
import Spin from 'antd/lib/spin';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from '../../../service/app_service'
import TopBarComponent from './../component/topbar_component'
import ModalComponent from './../component/modal_component'
import SockJsClient from 'react-stomp';
import UrlService from './../../../service/url_service'
import AuthenticationService from './../../../service/authentication_service'
import { messaging, requestForToken } from "./../../../firebase/firebase";
import { usePaystackPayment } from 'react-paystack';
const {Option} = Select;

var interval = null;
var downloadTimer = null;
const DashboardPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [dashboard, setDashboard] = useState(0);
    const [giveawaySummary, setGiveawaySummary] = useState({});
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    
    const [showModal, setShowModal] = useState(false);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [key, setKey] = useState(null);
    const [reference, setReference] = useState(null);
    const [account, setAccount] = useState(null);
    const [amount, setAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [fees, setFees] = useState(0);
    const [narration, setNarration] = useState('');
    
    
    const [profileTab, setProfileTab] = useState(2);
    const [userTransactions, setUserTransactions] = useState(0);
    const [userTransactionsPageSize, setUserTransactionsPageSize] = useState(10);
    const [userTransactionsPageNumber, setUserTransactionsPageNumber] = useState(1);
    const [totalUserTransactionCount, setTotalUserTransactionCount] = useState(0);

    const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
    const [showBuyAirtimeModal, setShowBuyAirtimeModal] = useState(false);
    const [showPeerToPeerModal, setShowPeerToPeerModal] = useState(false);
    const [showIdentificationModal, setShowIdentificationModal] = useState(false);
    const [loadingWithdrawal, setLoadingWithdrawal] = useState(false);
    const [loadingBuyAirtime, setLoadingBuyAirtime] = useState(false);
    const [banks, setBanks] = useState(null);
    const [bankCode, setBankCode] = useState(null);
    const [accountName, setAccountName] = useState('');
    const [accountNumberTemp, setAccountNumberTemp] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [networkCode, setNetworkCode] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [accountDetail, setAccountDetail] = useState(null);
    const [identificationType, setIdentificationType] = useState(null);
    const [data, setData] = useState(null);
    const [number, setNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [platform, setPlatform] = useState(null);
    const [showTransfering, setShowTransfering] = useState(false);
    

    const [identityVerified, setIdentityVerified] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    
    


    const [clientRef, setClientRef] = useState(null);
    const [orderRef, setOrderRef] = useState((new Date()).getTime().toString());
    const [channel, setChannel] = useState(null);

    useEffect(() => {
        setChannel(channelGenerator());
        getCustomerDashboard();
        getGiveawaySummary();
        getTransactions(pageNumber);
        getUserTransactions(userTransactionsPageNumber);
        loadFcm();
        getAccountDetail();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        //eslint-disable-next-line
    }, []);


    const  loadFcm = async () => {
        if (messaging) {
            requestForToken().then((token) => {
                console.log("Token = " + token);
                if(token) {
                        let localToken = AuthenticationService.getFcmToken();
                        if (localToken !== token && AuthenticationService.getToken()) {
                            console.log("Setting new token")
                            AuthenticationService.setFcmToken(token);
                            let data = {};
                            data.fcm = token;
                            //data.userId = AuthenticationService.getId();
                            AppService.updateAccountFcm(data)
                                .then(response => {
                                    if (response.code) {
                                        AuthenticationService.setFcmToken(null);
                                    } else {
                                        // message.success("Token registration was successful")
                                    }
      
                                })
                        } else {
                            console.log("Setting nothing")
                        }
                }
            });
            
            
            navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
  
            // messaging.onMessage((payload) => {
            //     console.log('Message received. ', payload);
            //     var noteTitle = payload.notification.title;
            //     var body = payload.notification.body;
            //     alert(body);
            // });
        }else {
            console.log("Messaging is null")
        }
  
  
  
    }
    const getCustomerDashboard = async () => {
        AppService.getCustomerDashboard().then(rec => {
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setDashboard(rec)
                if(!rec.settlementAccount){
                    getAccountDetail()
                }
            }
        })
    }

    const getCustomerDashboardRefresh = async () => {
        setLoading(true);
        AppService.getCustomerDashboardRefresh().then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setDashboard(rec)
            }
        })
    }

    const getAccountDetail = () => {
        setLoading(true);
        AppService.getAccountDetail().then(response => {
            setLoading(false)
            if (response.code) {
                message.error(response.description);
            } else {
                setAccountDetail(response);
                getCustomerDashboardRefresh();
            }

        })
    }

    const getGiveawaySummary = async () => {
        AppService.getGiveawaySummary().then(rec => {
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setGiveawaySummary(rec.data)
            }
        })
    }

    
    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getTransactions(pageSize, pageNumber).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setTransactions(rec.list)
                setTotalTransactionCount(rec.noOfRecords)
            }
        })
    }

    const getUserTransactions = async (userTransactionsPageNumber) => {
        setLoading(true);
        AppService.getUserTransactions(userTransactionsPageSize, userTransactionsPageNumber).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setUserTransactions(rec.list)
                setTotalUserTransactionCount(rec.noOfRecords)
            }
        })
    }

    const changePage= (val) =>{
        setPageNumber(val)
        getTransactions(val);
    }

    const changePageUserTransaction= (val) =>{
        setUserTransactionsPageNumber(val)
        getUserTransactions(val);
    }

    const paymentConfirmationCron = (ref) => {
        // navigator.serviceWorker.ready.then(registration => {
        //     interval = setInterval(() => {
        //         paymentConfirmation(false, ref);
        //         //registration.showNotification(title, options)
        //     }, 10000)
        // })
        interval = setInterval(() => {
            paymentConfirmation(false, ref);
        }, 10000)
    }

    const paymentConfirmation = (alerter, ref) => {
        setLoading(alerter);
        console.log("ref:",ref)
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.paymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    //call back for order to be checked out
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                    getCustomerDashboard();
                    getGiveawaySummary();
                    setShowGiveawayModal(false);
                    getCustomerDashboardRefresh();
                    getUserTransactions(1);
                    setShowTransfering(false)
                }
            } else {
                if(rec.description == 'Transaction has expired'){
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    message.error(rec.description);
                    setShowModal(false);
                }
                else if (alerter){
                    message.error(rec.description)
                }
                    
            }

        })

    }

    const startCounter = (timeleft) => {
        downloadTimer = setInterval(function () {
            if (timeleft <= 4) {
                clearInterval(downloadTimer);
                if (document.getElementById("countdown") != null)
                    document.getElementById("countdown").innerHTML = "Time is up";
            } else {
                var minutes = Math.floor(timeleft / 60);
                var seconds = timeleft - (minutes * 60);
                var left = minutes + ":" + seconds;
                var element = document.getElementById("countdown");
                if (element)
                    element.innerHTML = left;

            }
            timeleft -= 1;
        }, 1000);
    }
    
    const makePayment = () => {
        let codedMessage = "fundAccount:" + amount + '_1';
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.amount = amount;
        data.codedMessage = codedMessage;
        data.message = "FUND_ACCOUNT";
        clientRef.sendMessage('/app/make/payment', JSON.stringify(data));
        setLoading(true);
    };

    const makeWithdrawal = () => {
        let data = {};
        data.Amount = amount;
        data.BankCode = bankCode;
        data.AccountNumber = accountNumber;
        data.AccountName = accountName;
        data.Narration = narration;
        setLoadingWithdrawal(true);
        AppService.fundsWithdrawal(data).then(response => {
            setLoadingWithdrawal(false);
            if (response.responseCode != "00") {
                message.error(response.description);
            } else {
                message.success("Withdrawal was successful");
                setAmount(0);
                setAccountNumber('');
                setAccountNumberTemp('');
                setAccountName('');
                setNarration('');
                setShowWithdrawalModal(false);
                getCustomerDashboardRefresh();
                getUserTransactions(1);
            }
        })
    }

    const buyAirtime = () => {
        let data = {};
        data.Amount = amount;
        data.Code = networkCode;
        data.PhoneNumber = phoneNumber;
        setLoadingBuyAirtime(true);
        AppService.buyAirtime(data).then(response => {
            setLoadingBuyAirtime(false);
            if (response.responseCode != "00") {
                message.error(response.description);
            } else {
                message.success("Withdrawal was successful");
                setAmount(0);
                setPhoneNumber('');
                setShowBuyAirtimeModal(false);
                getCustomerDashboardRefresh();
            }
        })
    }

    const initiatePeerToPeer = () => {
        let data = {};
        data.amount = amount;
        data.mobileNumber = AuthenticationService.getMobileNumber();
        data.beneficiaryMobileNumber = phoneNumber;
        data.beneficiaryUsername = accountName;
        data.narration = narration;
        setLoadingWithdrawal(true);
        AppService.initiatePeerToPeer(data).then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.message);
            } else {
                message.success("Peer to Peer was successful");
                setAmount(0);
                setAccountNumber('');
                setAccountNumberTemp('');
                setAccountName('');
                setNarration('');
                setShowPeerToPeerModal(false);
                getCustomerDashboardRefresh();
            }
        })
    }

    const initiateFunding = () => {
        let data = {};
        data.amount = amount;
        data.toAccount = AuthenticationService.getMobileNumber();
        data.type = "FUND_WALLET";
        data.channel = channel;
        data.narration = narration;
        setLoadingWithdrawal(true);
        AppService.initiateFunding(data).then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.description);
            } else {
                message.success("Funding initiation was successful");
                setFees(response.fee);
                setKey(response.key);
                setReference(response.ref);
                setTotalAmount(response.amount);
                setPlatform(response.provider);
            }
        })
    }

     // you can call this function anything
    const onSuccess = (obj) => {
        // Implementation for whatever you want to do with reference and after success call.
        console.log(obj);
        AppService.confirmPayment(obj.reference).then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.description);
            } else {
                message.success("Funding completed and successful");
                setFees(0);
                setKey('');
                setReference('');
                setTotalAmount(0);
                setAmount(0);
                setNarration('');

                getTransactions(pageNumber);
                getCustomerDashboard();
                getGiveawaySummary();
                setShowGiveawayModal(false);
                getCustomerDashboardRefresh();
                getUserTransactions(1);
            }
        })
        
    };

    // you can call this function anything
    const onClose = () => {
        // implementation for  whatever you want to do when the Paystack dialog closed.
        console.log('closed')
    }

    const getConfig = () => {
        return {
            reference: reference,
            email: AuthenticationService.getEmail(),
            metadata: {
                phone: AuthenticationService.getMobileNumber(),
                name: AuthenticationService.getName()
            },
            amount: totalAmount * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
            publicKey: key,
        };
    }

    

    const PaystackHookExample = () => {
        const initializePayment = usePaystackPayment(getConfig());
        return (
          <div>
              <Popconfirm
              title="Are you sure to submit this transaction?"
              onConfirm={() => initializePayment(onSuccess, onClose)}
              okText="Yes"
              cancelText="No">
                <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Make Payment (&#8358; {formatAmount(totalAmount)})</button>
                </Popconfirm>
          </div>
        );
    };
    

    const getBanks = () => {
        setLoadingWithdrawal(true);
        AppService.getBanks().then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.description);
            } else {
                setBanks(response);
            }
        })
    }

    const nameEnquiry = (number) => {
        setAccountName(null);
        setLoadingWithdrawal(true);
        AppService.nameEnquiry(bankCode, number).then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.description);
            } else {
                setAccountName(response.accountName);
            }
        })
    }

    const getBeneficiaryUsername = (number) => {
        setAccountName(null);
        setLoadingWithdrawal(true);
        let data = {};
        data.beneficiaryMobileNumber = number;
        AppService.getBeneficiaryUsername(data).then(response => {
            setLoadingWithdrawal(false);
            if (response.code) {
                message.error(response.message);
            } else {
                setAccountName(response.beneficiaryUsername);
            }
        })
    }


    const handleChange = (e) => {
        if(e.target.name === 'amount'){
            setAmount(parseFloat(e.target.value));
        }else if(e.target.name === 'narration'){
            setNarration(e.target.value);
        }else if(e.target.name === 'accountNumber'){
            setAccountNumberTemp(e.target.value);
            if(e.target.value.length == 10) {
                setAccountNumber(e.target.value);
                nameEnquiry(e.target.value);
            }else {
                setAccountNumber('');
            }
            
        }else if(e.target.name === 'phoneNumber'){
            setPhoneNumber(e.target.value);
            if(showPeerToPeerModal && e.target.value.length == 11) {
                getBeneficiaryUsername(e.target.value);
            }
        }else if(e.target.name === 'identificationType'){
            setIdentificationType(e.target.value);
        }else if(e.target.name === 'number'){
            setNumber(e.target.value);
        }else if(e.target.name === 'otp'){
            setOtp(e.target.value);
        }
    }

    const handleBankChange = (value) => {
        setBankCode(value);
    }

    const handleNetworkChange = (e) => {
        setNetworkCode(e.target.value);
    }

    const formatAmount = (amount) => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    const setAmountState = (amount) => {
        setAmount(amount);
    }

    const channelGenerator = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    const closePaymentModal = () => {
        setShowModal(!showModal);
        clearInterval(interval);
        clearInterval(downloadTimer);
    }

    const providers = [
		{
			"Code": "airtel",
			"Name": "Airtel"
		},
		{
			"Code": "mtn",
			"Name": "MTN"
		},
		{
			"Code": "glo",
			"Name": "GLO"
		},
		{
			"Code": "etisalat",
			"Name": "Etisalat"
		}
	];

    const openWithdrawalModal = () => {
        setShowWithdrawalModal(true);
        getBanks();
    }

    const openIdentificationModal = () => {
        setShowIdentificationModal(true);
    }

    const validateIdentification = () => {
        setLoadingWithdrawal(true);
        setData(null);
        setIdentityVerified(false);
        setOtpSent(false);


        setErrorMessage('');

        let payload = {};
        payload.number = number;
        payload.identificationType = identificationType;

        AppService.validateIdentification(payload).then(rec => {
            if (rec) {
                setLoadingWithdrawal(false);
                if (rec.code !== "200") {
                    message.error(rec.message);
                    setErrorMessage(rec.message);
                } else {
                    message.success(rec.data.message);
                    setData(rec.data);
                    setIdentityVerified(true);
                    setOtpSent(rec.data.otpSent);
                }
            } else {
                message.error("Empty response")
            }
        })
    }

    const verifyOtp = () => {
        setLoadingWithdrawal(true);
        let payload = {};
        payload.number = number;
        payload.identificationType = identificationType;
        payload.otp = otp;
        payload.verifyPhoneNumber = true;
        setErrorMessage('');
        AppService.validateIdentification(payload).then(rec => {
            if (rec) {

                setLoadingWithdrawal(false);
                if (rec.code !== "200") {
                    message.error(rec.message);
                    setErrorMessage(rec.message);
                } else {
                    message.success("Successful")
                    setData(rec.data);
                    setIdentityVerified(true);
                }
            } else {
                message.error("Empty response")
            }
        })
    }

    const updateAccountDetailKycVerification = () => {
        setLoadingWithdrawal(true);
        let payload = {};
        payload.number = number;
        payload.identificationType = identificationType;
        payload.otp = otp;
        payload.verifyPhoneNumber = true;
        if(identificationType == "nin") {
            payload.nin = number;
        }
        if(identificationType == "bvn") {
            payload.bvn = number;
        }

        AppService.updateAccountDetailKycVerification(payload).then(rec => {
            if (rec) {

                setLoadingWithdrawal(false);
                if (rec.code && rec.code !== "200") {
                    message.error(rec.message);
                } else {
                    message.success("KYC Verification Completed Successful");
                    setShowIdentificationModal(false);
                    getCustomerDashboardRefresh();
                }
            } else {
                message.error("Empty response")
            }
        })
    }

    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="row">
                        {accountDetail && !accountDetail.kycVerified && <div className="col-md-12" style={{marginBottom: '15px'}}>
                            <Alert message="Pending Action:" description="Kindly Verify Your Identity" type="warning" />
                        </div>}
                        <div className="col-lg-4">
                            <div className="token-statistics card card-token height-auto">
                                <div className="card-innr">
                                    <div className="token-balance token-balance-with-icon">
                                        <div className="token-balance-icon"><img src="/assets/images/logo-light-sm.png" alt="logo" /></div>
                                        {(accountDetail && accountDetail.kycVerified) && <div className="token-balance-text">
                                            <h6 className="card-sub-title">Account Balance <em className="text-white ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getCustomerDashboardRefresh()} /></h6>
                                            <span className="lead">&#8358; {dashboard && dashboard.settlementAccount && formatAmount(dashboard.settlementAccount.balance)} <span></span></span>
                                        </div>}
                                    </div>
                                    {(accountDetail && accountDetail.kycVerified) && <div className="token-balance token-balance-s2">
                                        <h6 className="card-sub-title">Transaction Volume</h6>
                                        <ul className="token-balance-list">
                                            <li className="token-balance-sub"><span className="lead">&#8358;{giveawaySummary && giveawaySummary.totalAirtimeDisbursed && formatAmount(giveawaySummary.totalAirtimeDisbursed)}</span><span className="sub">AIRTIME</span></li>
                                            <li className="token-balance-sub"><span className="lead">&#8358;{giveawaySummary && giveawaySummary.totalAirtimeGiveaway && formatAmount(giveawaySummary.totalAirtimeGiveaway)}</span><span className="sub">GIVEAWAY</span></li>
                                        </ul>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {/* .col */}
                        <div className="col-lg-8">
                            <div className="token-information card card-full-height">
                                <div className="row no-gutters height-100">
                                    <div className="col-md-6 text-center">
                                        <div className="token-info">
                                            <img className="token-info-icon" src="/assets/images/logo-sm.png" alt="logo-sm" />
                                            <div className="gaps-2x" />
                                            {(accountDetail && accountDetail.kycVerified) && <h1 className="token-info-head text-light">Sent = &#8358; {dashboard && dashboard.transactionSummary && formatAmount(dashboard.transactionSummary.outAmount)}</h1>}
                                            {(accountDetail && accountDetail.kycVerified) && <h5 className="token-info-sub">Received = &#8358; {dashboard && dashboard.transactionSummary && formatAmount(dashboard.transactionSummary.inAmount)}</h5>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="token-info bdr-tl">
                                            <div>
                                                {(accountDetail && !accountDetail.kycVerified) && <Button type="primary" shape="round" size="medium" onClick={() => openIdentificationModal()} style={{margin: '5px 5px'}}><span>Verify My Identity</span></Button>}
                                                {dashboard && !dashboard.settlementAccount && <h5 className="kyc-alert text-danger" >Account information is missing</h5>}
                                                {dashboard && !dashboard.settlementAccount && <a className="btn btn-sm btn-outline btn-light" onClick={() => getAccountDetail()} style={{float: 'right'}}><em className="text-primary ti ti-reload" /><span>Resolve Account Issue</span></a>}
                                                {(accountDetail && accountDetail.kycVerified) && <Button type="primary" shape="round" icon={<PlusCircleTwoTone />} size="medium" onClick={() => setShowGiveawayModal(true)} style={{margin: '5px 5px'}}><span>Fund Account</span></Button>}
                                                {(accountDetail && accountDetail.kycVerified) && <Button type="primary" shape="round" icon={<PlusCircleTwoTone />} size="medium" onClick={() => setShowPeerToPeerModal(true)} style={{margin: '5px 5px'}}><span>Peer 2 Peer</span></Button>}
                                                
                                                <br />
                                                {(accountDetail && accountDetail.kycVerified) && <Button type="primary" shape="round" icon={<SendOutlined />} size="medium" onClick={() => openWithdrawalModal()} style={{margin: '5px 5px'}}><span>Withdraw Funds</span></Button>}
                                                
                                                {(accountDetail && accountDetail.kycVerified) && <Button type="primary" shape="round" icon={<SendOutlined />} size="medium" onClick={() => setShowBuyAirtimeModal(true)} style={{margin: '5px 5px'}}>Buy Airtime</Button>}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* .card */}
                        </div>
                        {/* .col */}


                        <div className="col-xl-4 col-lg-4 slidding">
                            <div  id="body" className="">
                                <div className="mobi-wrap">
                                    <div>
                                        <div className="float">
                                            <div className="spans">
                                            <span />
                                            <span />
                                            <span />
                                            <span />
                                            <span />
                                            <span />
                                            </div>
                                            <p className="p-icon">
                                            <i className="fa fa-mobile active" aria-hidden="true" />
                                            <i className="fa fa-child" aria-hidden="true" />
                                            <i className="fa fa-shopping-cart" aria-hidden="true" />
                                            <i className="fa fa-credit-card-alt" aria-hidden="true" />
                                            </p>
                                        </div>
                                        <ul className="slider">
                                            <li className="active">
                                            <div className="imgs"><img src="/assets/images/oneorbit_funding_account.png" /></div>
                                            <div className="desc">
                                                <p className="first"  onClick={() => setShowGiveawayModal(true)}>Verify & Fund Your Account</p>
                                                <p className="last"><strong>VERIFY YOUR ACCOUNT</strong> and then Click on <strong>FUND ACCOUNT</strong> button on your dashboard. Fund your account using our secured payment partner <strong>PAYSTACK</strong>. <br /> Proceed to then generate giveaways with the funds in your account.</p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="imgs"><img src="/assets/images/oneorbit_dogiveaway.png" /></div>
                                            <div className="desc">
                                                <p className="first">Giveaway</p>
                                                <p className="last">Starting generating giveaway links and sharing with friends and families. Define amount per giveaway, quantity of giveaway, game type, reward type.</p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="imgs"><img src="/assets/images/oneorbit_cash_withdrawal.png" /></div>
                                            <div className="desc">
                                                <p className="first">Withdraw Funds</p>
                                                <p className="last">You can withdraw your funds at any time to any bank account of your choice. All you have to do is select the bank and input withdrawal amount.</p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="imgs"><img src="https://cdn2.iconfinder.com/data/icons/business-finance-29/32/46_banking_business_connection_indian_rupee_money_payment-512.png" /></div>
                                            <div className="desc">
                                                <p className="first">Buy Airtime</p>
                                                <p className="last">Pay using debit card, credit card or any wallets. Get delivery by paying cash at ur place</p>
                                            </div>
                                            </li>
                                        </ul>
                                        <div className="actions">
                                            <button className="prev disabled">Back
                                            </button>
                                            <ul className="dots">
                                            <li className="active" />
                                            <li />
                                            <li />
                                            <li />
                                            </ul>
                                            <button className="next">Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-xl-8 col-lg-8">
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Transactions</h4>
                                    </div>
                                    <ul className="nav nav-tabs nav-tabs-line" role="tablist">
                                        <li className="nav-item"><a className={"nav-link " + (profileTab === 2 ? "show active" : "")} onClick={() => setProfileTab(2)} data-toggle="tab" >Transactions</a></li>
                                        {/* <li className="nav-item"><a className={"nav-link " + (profileTab === 1 ? "show active" : "")} onClick={() => setProfileTab(1)} data-toggle="tab" >Escrow Transactions</a></li> */}
                                    </ul>
                                    {/* .nav-tabs-line */}
                                    <div className="tab-content" id="profile-details">
                                        <div className={"tab-pane fade " + (profileTab === 1 ? "show active" : "")} id="personal-data">
                                            <div className="card-innr">
                                                <div className="card-head has-aside">
                                                    <h4 className="card-title">Escrow Transactions <em className="text-blue ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getTransactions(1)} /></h4>
                                                    <div className="card-opt">
                                                        <Link to="/transactions" className="link ucap">View ALL <em className="fas fa-angle-right ml-2" /></Link>  
                                                    </div>
                                                </div>
                                                <Spin spinning={loading}>
                                                <table className="table tnx-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Asset</th>
                                                            <th>Amount</th>
                                                            <th className="d-none d-sm-table-cell tnx-date">Date</th>
                                                            <th className="tnx-type">
                                                                <div className="tnx-type-text" />
                                                            </th>
                                                        </tr>
                                                        {/* tr */}
                                                    </thead>
                                                    {/* thead */}
                                                    <tbody>
                                                        {
                                                            transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                                return <tr key={i}>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className={"data-state "+(item.status === "COMPLETED" ? 'data-state-approved' : 'data-state-progress')} />
                                                                            <span className="lead">{item.name}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span>
                                                                            <span className="lead">&#8358; {parseFloat(item.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className="d-none d-sm-table-cell tnx-date"><span className="sub sub-s2">{(item.createdAt)}</span></td>
                                                                    <td className="tnx-type"><Link to={"/transaction/detail/"+item.ref}><span className={"" +(item.status === "COMPLETED" ? 'tnx-type-md badge badge-outline badge-success badge-md' : 'tnx-type-md badge badge-outline badge-warning badge-md')}  >View</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">P</span></Link> </td>
                                                                </tr>
                                                            })
                                                        }
                                                        {transactions && transactions.length > 0 && <tr>
                                                            <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                                        </tr>}

                                                        
                                                    </tbody>
                                                    {/* tbody */}
                                                </table>
                                                </Spin>
                                                {/* .table */}
                                            </div>
                                        </div>
                                        {/* .tab-pane */}
                                        <div className={"tab-pane fade " + (profileTab === 2 ? "show active" : "")} id="settings">
                                            <div className="card-innr">
                                                <div className="card-head has-aside">
                                                    <h4 className="card-title">My Transactions <em className="text-blue ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getUserTransactions(1)} /></h4>
                                                </div>
                                                <Spin spinning={loading}>
                                                <table className="table tnx-table bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Description</th>
                                                            <th>Amount</th>
                                                            <th className="tnx-type">
                                                                <div className="tnx-type-text" />
                                                            </th>
                                                            <th className="d-none d-sm-table-cell tnx-date">Date</th>
                                                        </tr>
                                                        {/* tr */}
                                                    </thead>
                                                    {/* thead */}
                                                    <tbody>
                                                        {
                                                            userTransactions && userTransactions.length > 0 && userTransactions.map((item, i) => {
                                                                return <tr key={i}>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className={"data-state "+(item.transactionType === "DEPOSIT" ? 'data-state-approved' : 'data-state-canceled')} />
                                                                            <span className="lead">{item.narration}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span>
                                                                            <span className="lead">&#8358; {parseFloat((item.inAmount > 0) ? item.inAmount : item.outAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className="tnx-type"><a style={{minWidth: '100px', marginLeft: '10px', marginRight: '10px'}} className={"btn btn-auto btn-xs "+ ((item.inAmount > 0) ? "btn-success" : "btn-warning")}>{item.transactionType}</a>  </td>
                                                                    <td className="d-none d-sm-table-cell tnx-date"><span className="sub sub-s2">{(item.createdAt)}</span></td>
                                                                </tr>
                                                            })
                                                        }
                                                        {transactions && transactions.length > 0 && <tr>
                                                            <Pagination onChange={changePageUserTransaction} pageSize={userTransactionsPageSize} defaultCurrent={userTransactionsPageNumber} current={userTransactionsPageNumber} total={totalUserTransactionCount} />
                                                        </tr>}

                                                        
                                                    </tbody>
                                                    {/* tbody */}
                                                </table>
                                                </Spin>
                                                {/* .table */}
                                            </div>
                                        </div>
                                        {/* .tab-pane */}
                                    </div>
                                    {/* .tab-content */}
                                </div>
                                {/* .card-innr */}
                            </div>
                        </div>
                        {/* <div className="col-xl-4 col-lg-5">
                            <div className="token-calculator card card-full-height" style={{height: 'auto'}}>
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Token Calculation</h4>
                                        <p className="card-title-text">Enter amount to calculate token.</p>
                                    </div>
                                    <div className="token-calc">
                                        <div className="token-pay-amount">
                                            <input id="token-base-amount" className="input-bordered input-with-hint" type="text" defaultValue={1} />
                                            <div className="token-pay-currency">
                                                <a href="#" className="link ucap link-light toggle-tigger toggle-caret">ETH</a>
                                                <div className="toggle-class dropdown-content">
                                                    <ul className="dropdown-list">
                                                        <li><a href="#">BTC</a></li>
                                                        <li><a href="#">LTC</a></li>
                                                        <li><a href="#">USD</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="token-received">
                                            <div className="token-eq-sign">=</div>
                                            <div className="token-received-amount">
                                                <h5 className="token-amount">123,500.84</h5>
                                                <div className="token-symbol">TWZ</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="token-calc-note note note-plane"><em className="fas fa-info-circle text-light" /><span className="note-text text-light">Amount calculated based current tokens price</span></div>
                                    <div className="token-buy"><a href="#" className="btn btn-primary">Buy Tokens</a></div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {/* .row */}

                </div>
                {/* .container */}
            </div>

            {showIdentificationModal && <ModalComponent show={setShowIdentificationModal} closeModal={() => {setShowIdentificationModal(false);}} title="Verify My Identity" >
                    <div >
                        <Spin spinning={loadingWithdrawal}>
                            <div className="row scroll-modal" >
                            {!otpSent && !data && <div>
                                    <div className="input-item input-with-label col-md-12">
                                        <label htmlFor="nationality" className="input-item-label">Select Means Of ID</label>
                                        <select className="input-bordered" name="identificationType" id="identificationType" onChange={handleChange} >
                                            <option value="select">Select Means Of ID</option>
                                            <option value="nin">NIN</option>
                                            <option value="bvn">BVN</option>
                                        </select>
                                    </div>

                                    {
                                        identificationType && <div className="input-item col-md-12">
                                                <label htmlFor="nationality" className="input-item-label">Enter {identificationType} number</label>
                                                <input type="text" onChange={handleChange} placeholder={'Enter your '+ identificationType} name="number" className="input-bordered" />
                                            </div>
                                    }

                                    <p style={{color: 'red'}}>{errorMessage}</p>
                                    <button className="btn btn-primary btn-block" onClick={validateIdentification}>Validate ID</button>
                                </div>}

                                {data  && otpSent && !data.data && <div style={{marginTop: '10px'}}>
                                        <div className="input-item">
                                            <p>{data.message}</p>
                                        <label htmlFor="otp" className="input-item-label">OTP</label>
                                        <input type="text" onChange={handleChange} placeholder="OTP" name="otp" className="input-bordered" />
                                    </div>

                                    <p style={{color: 'red'}}>{errorMessage}</p>
                                    <button className="btn btn-primary btn-block" onClick={verifyOtp}>Verify OTP</button>
                                    </div>
                                }


                                {data && data.data && <div className="col-md-12">
                                    <img src={data.data.image} style={{marginBottom: '10px', borderRadius: '50%', marginLeft: '30%', width: '200px', height: '200px'}} />
                                    <div className="input-item">
                                        <label htmlFor="firstName" className="input-item-label">Firstname</label>
                                        <input type="text" value={data.data.firstName} placeholder="Your First Name" name="firstName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="lastName" className="input-item-label">Lastname</label>
                                        <input type="text" value={data.data.lastName} placeholder="Your Last Name" name="lastName" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="email" className="input-item-label">Email</label>
                                        <input type="text" value={data.data.email} placeholder="Your Email" name="emailAddress" className="input-bordered" />
                                    </div>
                                    <div className="input-item">
                                        <label htmlFor="Phone" className="input-item-label">Phone Number</label>
                                        <input type="text" value={data.data.phone} placeholder="Phone number" name="mobileNumber" className="input-bordered" />
                                    </div>
                                    
                                    
                                    <div style={{color: 'red'}}>
                                    {
                                        !AuthenticationService.getName().toUpperCase().includes(data.data.firstName.toUpperCase()) && <p>
                                            * Firstname mismatch
                                        </p>
                                    }
                                    {
                                        !AuthenticationService.getName().toUpperCase().includes(data.data.lastName.toUpperCase()) && <p>
                                            * Lastname mismatch
                                        </p>
                                    }
                                    {
                                        !AuthenticationService.getMobileNumber().toUpperCase().includes(data.data.phone.toUpperCase()) && <p>
                                            * Phone number mismatch
                                        </p>
                                    }
                                    </div>

                                    {(!AuthenticationService.getName().toUpperCase().includes(data.data.firstName.toUpperCase()) || 
                                    !AuthenticationService.getName().toUpperCase().includes(data.data.lastName.toUpperCase()) || 
                                    !AuthenticationService.getMobileNumber().toUpperCase().includes(data.data.phone.toUpperCase())) &&<div style={{color: 'red'}}>
                                        <hr />
                                        <p>
                                           * Use Your Correct ID detail or Register again with the right information
                                        </p>
                                        <button className="btn btn-danger btn-block" onClick={() => {setOtpSent(false); setData(null)}}>Go Back</button>
                                    </div>}
                                    
                                </div>}

                                {data && data.data && AuthenticationService.getName().toUpperCase().includes(data.data.firstName.toUpperCase()) &&
                                  AuthenticationService.getName().toUpperCase().includes(data.data.lastName.toUpperCase()) && 
                                  AuthenticationService.getMobileNumber().toUpperCase().includes(data.data.phone.toUpperCase()) && <p>By Proceeding, you do confirm that the above information is correct.</p>}

                                {data && data.data && AuthenticationService.getName().toUpperCase().includes(data.data.firstName.toUpperCase()) &&
                                  AuthenticationService.getName().toUpperCase().includes(data.data.lastName.toUpperCase()) && 
                                  AuthenticationService.getMobileNumber().toUpperCase().includes(data.data.phone.toUpperCase()) && <div className="col-md-12">
                                    {<Popconfirm
                                        title="Are you sure to submit this?"
                                        onConfirm={updateAccountDetailKycVerification}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loadingWithdrawal} name="submit" className="btn btn-success btn-block">Complete KYC Verification</button>
                                    </Popconfirm>}
                                </div>}
                                

                            </div>
                        </Spin>
                    </div>
                </ModalComponent>}


            {showModal && <ModalComponent show={showModal} closeModal={() => closePaymentModal()} title="Make payment" >
                    <Spin spinning={loading}>
                    <div>

                        {!paymentSuccessful && <div>
                            <p>Please make a bank transfer to the account detail below.</p>
                            <div className="gaps-1x" />
                            {/* <h6 className="font-bold">Payment to the following bank detail</h6> */}
                            <div className="row">
                                <div className="col-sm-4">
                                    <h6 style={{paddingTop: '20px'}}>Account Number</h6>
                                </div>
                                <div className="col-sm-8">
                                    <div className="copy-wrap mgb-0-5x" style={{fontSize: '20px', fontWeight: 400}}>
                                        <span className="copy-feedback" style={{ display: 'none' }}>Copied to Clipboard</span>
                                        <em className="fab fa-account" />
                                        <input type="text" className="copy-address" style={{padding: '12px 30px 12px 20px'}} defaultValue={account && account.accountNumber} disabled />
                                        <button onClick={() => { navigator.clipboard.writeText(account && account.accountNumber); message.info(' Copied to Clipboard') }} className="copy-trigger copy-clipboard" data-clipboard-text={account && account.accountNumber}><em className="ti ti-files" /></button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* .copy-wrap */}
                            <ul className="pay-info-list row">
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Bank:</span> <strong>{account && account.bank}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Account Name:</span> <strong>{account && account.accountName}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Amount:</span> <strong style={{fontSize: '18px'}}>&#8358; {account && account.totalAmount && account.totalAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong></li>
                            </ul>
                            
                            <div style={{fontSize: '16px', color: 'red'}}>You have to make payment in the next <h5 id="countdown"></h5></div>
                            
                            <div className="note note-plane note-light mgb-1x" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Do not make payment to another account.  </p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Send the exact amount stated above. Nothing more, nothing less</p>
                            </div>
                            <div className="note note-plane note-light" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p><strong>For any payment or giveaway issues, call or send whatsapp to +2348060765123 for immediate support.</strong> </p>
                            </div>
                            <div className="gaps-3x" />
                            {showTransfering && <div class="containerStreaming">
                                    <div class="sound-wave">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    </div>
                                </div>}
                                <h4>Awaiting Transfer Confirmation</h4>
                            {false && <button className="btn btn-primary" style={{float: 'right'}} onClick={() => paymentConfirmation(true, orderRef)} >Confirm Payment  <em className="ti ti-arrow-right mgl-4-5x" /></button>}
                            
                        </div>}

                        {paymentSuccessful && <div className="status status-thank px-md-5">
                            <div className="status-icon"><em className="ti ti-check" /></div>
                            <span className="status-text large text-dark">Thank you for submitting form</span>
                            <p className="px-md-5">We received your data, our team will check and get back you via email.</p>
                        </div>}
                    </div>
                    </Spin>
                </ModalComponent>}

                {showGiveawayModal && <ModalComponent show={setShowGiveawayModal} closeModal={() => setShowGiveawayModal(false)} title="Add Funds" >
                    <div >
                        <Spin spinning={loading}>
                            <div className="row scroll-modal" >
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" value={amount} className="input-bordered" placeholder="Amount" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Narration</label>
                                        <input type="text" name="narration" value={narration} className="input-bordered" placeholder="Narration" onChange={handleChange} />
                                    </div>
                                </div>
                                

                                <hr />
                                <br />
                                <br />
                                <br />

                                {amount > 0 && fees == 0 && <button type="submit" disabled={loading} onClick={() => initiateFunding()} name="submit" className="btn btn-primary btn-block">Proceed</button>}
                                

                                {amount > 0 && fees > 0 && <div className="col-md-12">
                                    <h6>Reference : {reference}</h6>
                                    <h6>Fee : &#8358; {fees}</h6>
                                    <h6>Total Amount : &#8358; {formatAmount(totalAmount)}</h6>
                                    {platform == "paystack" && <PaystackHookExample />}
                                    {false && <Popconfirm
                                        onConfirm={makePayment}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Bank Transfer (&#8358; {formatAmount(100 + amount)})</button>
                                    </Popconfirm>}
                                </div>}
                                
                                

                            </div>
                        </Spin>
                    </div>
                </ModalComponent>}


                {showWithdrawalModal && <ModalComponent show={setShowWithdrawalModal} closeModal={() => setShowWithdrawalModal(false)} title="Withdrawal" >
                    <div >
                        <Spin spinning={loadingWithdrawal}>
                            <div className="row scroll-modal" >
                            <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Bank</label>
                                        <br />
                                        <Select
                                            showSearch
                                            placeholder="Select Your Bank"
                                            optionFilterProp="children"
                                            minWidth="100%"
                                            onChange={handleBankChange}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {banks && banks.length > 0 && banks.map(function (item, idx) {
                                                return (<Option key={idx} value={item.BankCode}>{item.BankName}</Option>)
                                            })
                                            }
                                        </Select>
                                    </div>
                                </div>

                                {bankCode && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Account Number</label>
                                        <input  type="text" pattern="\d*" maxLength={10} name="accountNumber" value={accountNumberTemp} className="input-bordered" placeholder="Account Number" onChange={handleChange} />
                                    </div>
                                </div>}

                                {accountName && <div className="col-md-12">
                                    <h5>{accountName}</h5>
                                </div>}


                                {accountName && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" value={amount} className="input-bordered" placeholder="Amount" onChange={handleChange} />
                                    </div>
                                </div>}

                                {accountName && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Narration</label>
                                        <input type="text" name="narration" value={narration} className="input-bordered" placeholder="Narration" onChange={handleChange} />
                                    </div>
                                </div>}
                                
                                

                                

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {amount > 0 && accountName && <div className="col-md-12">
                                    <h6>Amount = &#8358; {formatAmount(amount)}</h6>
                                    {<Popconfirm
                                        title="Are you sure to submit this withdrawal?"
                                        onConfirm={makeWithdrawal}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loadingWithdrawal} name="submit" className="btn btn-success btn-block">Withdraw (&#8358; {formatAmount(amount)})</button>
                                    </Popconfirm>}
                                </div>}
                                

                            </div>
                        </Spin>
                    </div>
                </ModalComponent>}





                {showBuyAirtimeModal && <ModalComponent show={setShowBuyAirtimeModal} closeModal={() => setShowBuyAirtimeModal(false)} title="Buy Airtime" >
                    <div >
                        <Spin spinning={loadingBuyAirtime}>
                            <div className="row scroll-modal" >
                            <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Network</label>
                                        <select name="role" className="input-bordered"   onChange={handleNetworkChange} >
                                            <option key="nothing" value="" >Select network</option>
                                            {providers && providers.length > 0 && providers.map(function (item, idx) {
                                                return (<option key={idx} value={item.Code}>{item.Name}</option>)
                                            })
                                            }
                                        </select>
                                    </div>
                                </div>

                                {networkCode && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Phone Number</label>
                                        <input  type="text" pattern="\d*" maxLength={11} name="phoneNumber" value={phoneNumber} className="input-bordered" placeholder="Phone Number" onChange={handleChange} />
                                    </div>
                                </div>}


                                {phoneNumber && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" value={amount} className="input-bordered" placeholder="Amount" onChange={handleChange} />
                                    </div>
                                </div>}
                                

                                

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {amount > 0 && <div className="col-md-12">
                                    <h6>Amount = &#8358; {formatAmount(amount)}</h6>
                                    {<Popconfirm
                                        title="Are you sure to submit this?"
                                        onConfirm={buyAirtime}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loadingWithdrawal} name="submit" className="btn btn-success btn-block">Buy {networkCode} (&#8358; {formatAmount(amount)})</button>
                                    </Popconfirm>}
                                </div>}
                                

                            </div>
                        </Spin>
                    </div>
                </ModalComponent>}

                {showPeerToPeerModal && <ModalComponent show={setShowPeerToPeerModal} closeModal={() => setShowPeerToPeerModal(false)} title="Peer To Peer" >
                    <div >
                        <Spin spinning={loadingBuyAirtime}>
                            <div className="row scroll-modal" >

                                {<div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Phone Number</label>
                                        <input  type="text" pattern="\d*" maxLength={11} name="phoneNumber" value={phoneNumber} className="input-bordered" placeholder="Phone Number" onChange={handleChange} />
                                    </div>
                                </div>}


                                {phoneNumber && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" value={amount} className="input-bordered" placeholder="Amount" onChange={handleChange} />
                                    </div>
                                </div>}
                                {accountName && <div className="col-md-12">
                                    <h5>{accountName}</h5>
                                </div>}
                                {accountName && <div className="col-md-12">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Narration</label>
                                        <input type="text" name="narration" value={narration} className="input-bordered" placeholder="Narration" onChange={handleChange} />
                                    </div>
                                </div>}
                                

                                

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {amount > 0 && <div className="col-md-12">
                                    <h6>Amount = &#8358; {formatAmount(amount)}</h6>
                                    {<Popconfirm
                                        title="Are you sure to submit this?"
                                        onConfirm={initiatePeerToPeer}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loadingWithdrawal} name="submit" className="btn btn-success btn-block">Send (&#8358; {formatAmount(amount)})</button>
                                    </Popconfirm>}
                                </div>}
                                

                            </div>
                        </Spin>
                    </div>
                </ModalComponent>}


                {<SockJsClient url={UrlService.BASE_PATH + '/unified/'}
                    topics={['/queue/chat/' + channel]}
                    onConnect={() => {
                        console.log("connected");
                        let data = {};
                        data.channel = channel;
                    }}
                    onDisconnect={() => {
                        console.log("Disconnected");
                    }}
                    onMessage={(msg) => {
                        console.log("mssg", msg)
                        if (msg.action === "MAKE_PAYMENT") {
                            setShowGiveawayModal(false);
                            setAccount(msg.account);
                            setAmountState(msg.order.totalAmount);
                            setOrderRef(msg.order.orderRef);
                            setShowModal(true);
                            setLoading(false);
                            startCounter(msg.timeFrame * 60);
                            paymentConfirmationCron(msg.order.orderRef);
                            setShowTransfering(true);
                        } else if (msg.action === "ERROR") {
                            setShowGiveawayModal(false);
                            setLoading(false);
                            message.error(msg.message);
                            getTransactions(pageNumber);
                        }
                    }}
                    ref={(client) => {
                        setClientRef(client);
                    }} />}
            {process.env.NODE_ENV}
        </div>
    );

}

export default withRouter(DashboardPage);
